// KD-3581 — extras live on the day that owns them (`day.selectedExtras`), so
// splicing the `days` array already carries each day's own selection along
// with it; nothing needs to be dropped or shifted for that. What still needs
// fixing up is the `dayIndex` FIELD each extra carries on itself (read by the
// day/global scope filters and by the save payload): it names the array
// position the extra was filed at, which just moved.
export function resyncExtrasDayIndex(days: any[]): any[] {
  return days.map((day, idx) =>
    Array.isArray(day.selectedExtras) && day.selectedExtras.length > 0
      ? {
          ...day,
          selectedExtras: day.selectedExtras.map((extra: any) =>
            extra?.dayIndex === idx ? extra : { ...extra, dayIndex: idx },
          ),
        }
      : day,
  );
}
